<div class="visually-hidden"
     role="region"
     aria-live="polite"
     id="pageInfo" [innerHTML]="pageinfo"></div>

<section *ngIf="currentVMModuleStatus==='open'">
  <div class="gd__container gd--ccgap">
    <div class="gd__container">
      <div class="mcbx inleiding"
           tabindex="0">
        <h1 class="mcbx__title" 
            [innerHTML]="currentVMModule.naam"></h1>
        <div class="richtext" [innerHTML]="pageContentCheck"></div>
      </div>
    </div>

    <div class="gd__container gd--13 gd--questions">
      <div *ngFor="let vraag of actualQuestions; index as i" class="cc__vraag" id="{{vraag.id}}">
        <div class="mcbx">
          <h2 class="mcbx__title" [innerHTML]="vraag.content[0].value"></h2>
          <div class="mcbx__sup">{{vraagSupTitle}} {{i+1}}/{{totalQuestions}}</div>
          <div *ngIf="vraag.vraagType == 'Multiple'" 
               class="mcbx__sub" 
               [innerHTML]="multipleChoiceText"></div>
          <div *ngIf="vraag.vraagType == 'Single'" 
               class="mcbx__sub"
               [innerHTML]="singleChoiceText"></div>
        </div>
        <fieldset *ngIf="vraag.vraagType == 'Multiple'" >
          <legend [innerHTML]="vraag.content[0].value + ' - ' + multipleChoiceText"
                  class="visually-hidden"></legend>
          <div class="gd__container gd--12">
            <label for="{{antwoord.id}}" 
                  *ngFor="let antwoord of vraag.antwoorden" 
                  class="cc__antwoord">
              <input type="checkbox" 
                    id="{{antwoord.id}}" 
                    name="{{vraag.id}}" 
                    value="{{antwoord.id}}" 
                    checked={{antwoord.checked}} 
                    (change)="checkValue(vraag.id, antwoord.id, i+1)" 
                    tabindex="0"/>
              <span class="cca__checkmark"></span>
              <span [innerHTML]="antwoord.tekst"></span>
            </label>
          </div>
        </fieldset>
        <fieldset *ngIf="vraag.vraagType == 'Single'">
          <legend [innerHTML]="vraag.content[0].value + ' - ' + singleChoiceText"
                  class="visually-hidden"></legend>
          <div class="gd__container gd--12">
            <label for="{{antwoord.id}}" 
                    *ngFor="let antwoord of vraag.antwoorden" 
                    class="cc__antwoord">
              <input type="radio" 
                    id="{{antwoord.id}}" 
                    name="{{vraag.id}}" 
                    value="{{antwoord.id}}" 
                    checked={{antwoord.checked}} 
                    (change)="checkValueRadio(vraag.id, antwoord.id, i+1)"
                    tabindex="0" />
              <span class="cca__radio"></span>
              <span [innerHTML]="antwoord.tekst"></span>
            </label>
          </div>
        </fieldset>
      </div>
    </div>

    <div *ngIf="showFinal" 
         class="gd__container">
      <div class="mcbx">
        <div class="mcbx__actions">
          <button (click)="actionClicked()" 
                  class="button" 
                  id="ipoclick-btn-{{paza}}-{{pagename}}-{{currentVMModule.key}}_resultaat" 
                  attr.aria-label="{{progressTextDone}}" 
                  [innerHTML]="progressTextDone"></button>
        </div>
      </div>
    </div>
  </div>
</section>

<section *ngIf="isReady && currentVMModuleStatus!='open'">
  <div class="gd__container gd--ccgap">
    <div class="gd__container">
      <div class="mcbx inleiding"
           tabindex="0">
        <h1 class="mcbx__title" 
            [innerHTML]="pageTitle"></h1>
        <div class="cct__badge">
          <img src="/assets/images/{{currentVMModule.status}}.png" alt="{{badgeAltText}}" width="88" height="132">
        </div>
        <div class="richtext" [innerHTML]="tipsContent"></div>
      </div>
    </div>

    <div class="gd__container">
      <div class="mcbx">
        <h2 class="mcbx__title" [innerHTML]="tipsTitle"></h2>
      </div>
      <div class="gd__container gd--13">
        <div *ngFor="let tip of currentVMTips" class="cc__tip">
          <h3 class="cct__title" [innerHTML]="tip.content.titleShort"></h3>
          <div class="richtext" [innerHTML]="tip.content.contentShort"></div>
          <div class="cct__actions">
            <button (click)="goToTip(tip.id)" 
                    class="button button--text right-icon" 
                    id="ipoclick-btn-{{paza}}-{{pagename}}-score_tip_{{tip.id}}"
                    attr.aria-label="{{tipLinkAria}} {{tip.content.titleShort}}"
                    [innerHTML]="tipLinkText"></button>
          </div>
        </div>
      </div>
    </div>
      
    <div class="gd__container">
      <div class="mcbx">
        <h2 class="mcbx__title" [innerHTML]="nextTitle"></h2>
        <div class="mcbx__actions">
          <button (click)="goToOverzicht()" 
              class="button" 
              id="ipoclick-btn-{{paza}}-{{pagename}}-{{currentVMModule.key}}_score_overzicht"
              attr.aria-label="{{nextOverzicht}}"
              [innerHTML]="nextOverzicht"></button>
        </div>
      </div>
    </div>
  </div>
</section>
